import { API_URL } from "../config/config";
import { deleteRequest, getRequest, postRequest, putRequest } from "../utils/axiosUtils";

export const fetchUtmList = async ({ setUtmOptions }) => {
  try {
    const res = await getRequest({
      url: `${API_URL}/admin/analytics/getUtmList`,
    });
    if (!res) return
    if (res.status >= 200 && res.status < 300 && res.data) {
      setUtmOptions(res.data.data);
      return res.data.data;
    } else {
      throw new Error(`Unexpected response code: ${res.status}`);
    }
  } catch (error) {
    console.error("Failed to fetch UTM list:", error);
    throw error;
  }
};
//     .get("/all", getAllUtmManager)
// .post("/save", addUtmManager)
// .put("/edit/:id", editUtmManager)
// .delete("/delete/:id",deleteUtmManager)


export const getAllUtmList = async (params = {}) => {
  try {
    const res = await getRequest({
      url: `${API_URL}/admin/utm_manager/all`,
      params,
    });
    if (!res) return
    if (res.status >= 200 && res.status < 300 && res.data) {
      return res.data.data;
    } else {
      throw new Error(`Unexpected response code: ${res.status}`);
    }
  } catch (error) {
    console.error("Failed to fetch UTM list:", error);
    throw error;
  }
};


export const saveUtmManager = async (data) => {
  try {
    const res = await postRequest({
      url: `${API_URL}/admin/utm_manager/save`,
      data,
    });
    if (!res) return
    if (res.status >= 200 && res.status < 300 && res.data) {
      return res.data.data;
    } else {
      throw new Error(`Unexpected response code: ${res.status}`);
    }
  } catch (error) {
    console.error("Failed to save UTM manager:", error);
    throw error;
  }
};


export const editUtmManager = async (data) => {
  try {
    const res = await putRequest({
      url: `${API_URL}/admin/utm_manager/edit/${data.id}`,
      data,
    });
    if (!res) return
    if (res.status >= 200 && res.status < 300 && res.data) {
      return res.data.data;
    } else {
      throw new Error(`Unexpected response code: ${res.status}`);
    }
  } catch (error) {
    console.error("Failed to edit UTM manager:", error);
    throw error;
  }
};

export const deleteUtmManager = async (id) => {
  try {
    const res = await deleteRequest({
      url: `${API_URL}/admin/utm_manager/delete/${id}`,
    });
    if (!res) return;
    if (res.status >= 200 && res.status < 300 && res.data) {
      return res.data.data;
    } else {
      throw new Error(`Unexpected response code: ${res.status}`);
    }
  } catch (error) {
    console.error("Failed to delete UTM manager:", error);
    throw error;
  }
};

